import { render, staticRenderFns } from "./LogoutDialog.vue?vue&type=template&id=c08ab7d2&scoped=true"
import script from "./LogoutDialog.vue?vue&type=script&lang=js"
export * from "./LogoutDialog.vue?vue&type=script&lang=js"
import style0 from "./LogoutDialog.vue?vue&type=style&index=0&id=c08ab7d2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08ab7d2",
  null
  
)

export default component.exports